import { isUserInterestedParties, getLegalDocuments } from '../services/legal_documents.service';

const IS_USER_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES = 'IS_USER_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES';
const USER_IS_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES = 'USER_IS_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES';
const USER_IS_NOT_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES = 'USER_IS_NOT_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES';
const GET_LEGAL_DOCUMENTS_TABLE = 'GET_LEGAL_DOCUMENTS_TABLE';
const LEGAL_DOCUMENTS_TABLE_LOADED = 'LEGAL_DOCUMENTS_TABLE_LOADED';
const LEGAL_DOCUMENTS_API_ERROR = 'LEGAL_DOCUMENTS_API_ERROR';

const events = [
  IS_USER_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
  USER_IS_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
  USER_IS_NOT_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
  GET_LEGAL_DOCUMENTS_TABLE,
  LEGAL_DOCUMENTS_TABLE_LOADED,
  LEGAL_DOCUMENTS_API_ERROR,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(IS_USER_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES, ({
    propertyId,
    entityId,
  }) => {
    isUserInterestedParties({
      propertyId,
      entityId,
      onResponse: ({ data }) => {
        if (data.is_user_in_legal_documents_interested_parties == true) {
          EVENT_BUS.dispatch(USER_IS_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES);
        } else {
          EVENT_BUS.dispatch(USER_IS_NOT_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES);
        }
      },
      onError: (err) => EVENT_BUS.dispatch(LEGAL_DOCUMENTS_API_ERROR),
    });
  });

  EVENT_BUS.on(GET_LEGAL_DOCUMENTS_TABLE, ({
    propertyId,
    entityId,
    subscriberCountryId,
  }) => {
    getLegalDocuments({
      propertyId,
      entityId,
      subscriberCountryId,
      onResponse: ({ data }) => {
        EVENT_BUS.dispatch(LEGAL_DOCUMENTS_TABLE_LOADED, { data: data });
      },
      onError: (err) => EVENT_BUS.dispatch(LEGAL_DOCUMENTS_API_ERROR),
    });
  });


};

export const LEGAL_DOCUMENTS_EVENTS = {
  IS_USER_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
  USER_IS_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
  USER_IS_NOT_IN_LEGAL_DOCUMENTS_INTERESTED_PARTIES,
  GET_LEGAL_DOCUMENTS_TABLE,
  LEGAL_DOCUMENTS_TABLE_LOADED,
  LEGAL_DOCUMENTS_API_ERROR,
  initializeEventListeners,
};
